import Swiper, { Pagination, Navigation, Autoplay, Parallax } from 'swiper'
import SwiperVideoNavigation from './swiper-video-navigation'

Swiper.use([Pagination, Navigation, Autoplay, Parallax])

const NoiSwiper = {
  init(): void {
    window.addEventListener(
      'load',
      () => {
        if (document.querySelector('.swiper-container') && !document.querySelector('.swiper-container')?.classList.contains('recipes__swiper__container')) {
          new Swiper('.swiper-container', {
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            autoplay: {
              delay: 7000,
              disableOnInteraction: false,
            },
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 30,
          })
        }
    
        if (document.querySelector('.recipes__swiper__container')) {
          const recipesSwiper = new Swiper('.recipes__swiper__container', {
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            parallax: true,
            autoplay: {
              delay: 7000,
              disableOnInteraction: false,
            },
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 30,
          })
          SwiperVideoNavigation(recipesSwiper)
        }
      },
      false
    )
  }
}

export default NoiSwiper